export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
            <div className="flex-1 w-full max-w-[520px]">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20home%20theater%20setup%20with%20warm%20ambient%20lighting%2C%20large%20screen%20displaying%20cinematic%20glow%2C%20comfortable%20modern%20living%20room%20setting%2C%20rich%20dark%20wood%20tones%20with%20golden%20accent%20lighting%2C%20cozy%20sophisticated%20atmosphere%2C%20premium%20viewing%20experience%20aesthetic%2C%20warm%20amber%20and%20deep%20burgundy%20color%20palette&width=1040&height=780&seq=about-cinema&orientation=landscape"
                  alt="成全影院品牌介绍"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-4 whitespace-nowrap">
                关于我们
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
                成全影院 - 你的私人影视库
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                成全影院成立于2020年，始终秉持"让每个人都能轻松看上好电影"的理念。平台收录超过十万部优质影视资源，涵盖电影大全、电视剧全集、综艺大全最新影片等多种类型。我们坚持每日更新，确保您能第一时间看到最新内容。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                采用先进的视频分发技术，保障高清画质流畅不卡顿，无论您是追剧达人还是电影发烧友，成全影院都是您的最佳选择。
              </p>
              <div className="grid grid-cols-3 gap-4 text-center">
                {[
                  { num: '5+', label: '运营年限' },
                  { num: '10万+', label: '影视资源' },
                  { num: '500万+', label: '月活用户' },
                ].map((s) => (
                  <div key={s.label} className="p-3 rounded-lg bg-background-100">
                    <p className="font-heading text-xl md:text-2xl font-bold text-primary-600">{s.num}</p>
                    <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}